import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    autoImport: false,

    state() {
        return {
            data: null,
            instructor: null,
            replies: null,
            courseId: null,
            id: null,
            totalAverageResponse: null,
            links: null,
            meta: null,
        };
    },

    getters: {},

    actions: {},

    mutations: {
        EDIT(state, payload) {
            state.data = payload.data;

            state.meta = payload.meta;
        },
    },
});
